import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const plexLearnNowContainer = css`
  ${flex('column', '')};
`;

export const rowContainer = css`
  ${flex('row', 'space-between')};
`;

export const firstQuestion = css`
  ${ZeeFontBold(16, 22)};
  color: ${colors.black};
  ${MQ.MediaLg} {
    ${ZeeFontBold(18, 24)};
  }
`;

export const firstAnswer = css`
  ${ZeeFontRegular(14, 18)};
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
  padding-top: 8px;
`;

export const plexLearnNowFAQ = css`
  ${ZeeFontBold(14, 18)};
  color: ${colors.black};
  padding-top: 20px;
`;

export const plexLearnNowHeader = css`
  padding: 20px 0 20px;
`;

export const buttonStyle = css`
  padding: 12px 40px;
  margin: 12px 0 32px;
  height: 52px;
  ${flex()};
  ${MQ.MediaSm} {
    width: 70%;
  }
`;

export const buttonText = css`
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontRegular(14, 18)};
`;
